import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { FieldDiarySummary } from './types';

interface UseGetFieldDiaryDashboardParams {
	propId?: string;
	forBinding?: string;
	month?: string;
	enabled?: boolean;
}

export const useGetFieldDiaryDashboard = ({
	propId,
	month,
	forBinding: ownerForBinding,
	enabled = true,
}: UseGetFieldDiaryDashboardParams) => {
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	return useQuery({
		queryKey: ['fieldDiary', 'dashboard', forBinding, propId, month],
		enabled: enabled && !!propId,
		queryFn: async () => {
			const { data } = await api.get<{ data: { summary: FieldDiarySummary } }>(
				'/field-diary/dashboard/get',
				{ params: { forBinding, propId, month } }
			);
			return data.data.summary;
		},
	});
};
